import React, { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import PropTypes from 'prop-types'
import { DropZone, Text } from './style'
const rABS = typeof FileReader !== 'undefined' && FileReader.prototype && FileReader.prototype.readAsBinaryString

function fixdata(data) {
    var o = '',
        l = 0,
        w = 10240
    for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)))
    o += String.fromCharCode.apply(null, new Uint8Array(data.slice(o.length)))
    return o
}
function DragNDrop({ handleDropData, title, backgroundColor, handleDropFiles }) {
    function onload(e) {
        let data = e.target.result
        let arr
        const readtype = { type: rABS ? 'binary' : 'base64' }
        readtype.cellDates = true
        if (!rABS) {
            arr = fixdata(data)
            data = btoa(arr)
        }
        handleDropData(data, readtype)
    }

    const onDrop = useCallback(files => {
        if (handleDropFiles) {
            handleDropFiles(files)
        }
        if (handleDropData) {
            let i, f
            for (i = 0, f = files[i]; i != files.length; ++i) {
                let reader = new FileReader()
                // let name = f.name
                reader.onload = onload
                if (rABS) reader.readAsBinaryString(f)
                else reader.readAsArrayBuffer(f)
            }
        }
    }, [])
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

    return (
        <DropZone {...getRootProps()} style={{ backgroundColor: backgroundColor }}>
            <input {...getInputProps()} />
            {isDragActive ? <Text>Drop the files here ...</Text> : <Text>{title}</Text>}
        </DropZone>
    )
}

DragNDrop.propTypes = {
    handleDropData: PropTypes.func,
    title: PropTypes.string,
    backgroundColor: PropTypes.string,
    handleDropFiles: PropTypes.func,
}
export default DragNDrop
